// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"genre-dropdown_dropdown__xHikJ"};